import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import { useDispatch, useSelector } from 'react-redux';

import { selectors as accountsSelector } from 'store/reducers/accounts';
import {
  getSummarizeDoctorList,
  selectors as doctorsSelector,
} from 'features/doctors';
import Snackbar from 'features/snackbar/Snackbar';
import IEDialog from 'components/Dialogs/IEDialog';
import routes from './routes';

function App(): React.ReactElement {
  const dispatch = useDispatch();
  const [openIeModal, setOpenIeModal] = useState(false);

  const { summarizeDoctorList } = useSelector(doctorsSelector.summarizeList);
  const { user } = useSelector(accountsSelector.user);

  useEffect(() => {
    if (user?.doctor && !summarizeDoctorList) {
      dispatch(getSummarizeDoctorList());
    }
  }, [dispatch, user, summarizeDoctorList]);

  useEffect(() => {
    const agent = navigator.userAgent.toLowerCase();
    if (
      (navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) ||
      agent.indexOf('msie') !== -1
    ) {
      setOpenIeModal(true);
    }
  }, []);

  return (
    <div id="layout">
      <Helmet>
        <title>마인드차트</title>
      </Helmet>
      {routes}
      <Snackbar />
      {openIeModal && <IEDialog />}
    </div>
  );
}

export default App;
